var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
// Circular deps means we have to access helpers directly
import getMessage from "@irati/utils/lang/helpers/getMessage";
import { injectIntl } from "@irati/utils/lang/injectIntl";
import { getErrorValues } from "@irati/utils/lang/formatError";
import ErrorText from "../ErrorText";
var LoadingError = /** @class */ (function (_super) {
    __extends(LoadingError, _super);
    function LoadingError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingError.prototype.render = function () {
        var _a = this.props, error = _a.error, formatMessage = _a.formatMessage, errorMsg = _a.errorMsg;
        return React.createElement(ErrorText, __assign({}, this.props), getMessage(formatMessage, errorMsg, getErrorValues(error)));
    };
    return LoadingError;
}(Component));
export default injectIntl(LoadingError);
